<template>
    <div v-show="visible" class="loading-bar" :style="barStyle"></div>
</template>

<script>
import { getSectionColor, SECTION_COLORS } from '@/utils/sectionColors'

export default {
    data() {
        return {
            visible: false,
            width: 0,
            finishing: false,
            color: null,
        }
    },
    computed: {
        barStyle() {
            const c = this.color || SECTION_COLORS.campaign
            return {
                width: this.width + '%',
                backgroundColor: c.bg,
                boxShadow: `0 0 8px ${c.shadow}`,
                transition: this.finishing
                    ? 'width 0.2s ease, opacity 0.3s ease 0.2s'
                    : 'width 8s cubic-bezier(0.1, 0.05, 0, 1)',
                opacity: this.finishing ? 0 : 1,
            }
        },
    },
    mounted() {
        this._removeBeforeEach = this.$router.beforeEach((to) => {
            clearTimeout(this._finishTimer)
            this.finishing = false
            this.color = getSectionColor(to.name) || SECTION_COLORS.campaign
            this.width = 0
            this.visible = true
            // Force a reflow so the bar starts from 0 before animating to 80
            if (this.$el) void this.$el.offsetWidth
            this.width = 80
        })

        this._removeAfterEach = this.$router.afterEach(() => {
            this.finishing = true
            this.width = 100
            this._finishTimer = setTimeout(() => {
                this.visible = false
                this.width = 0
                this.finishing = false
            }, 500)
        })
    },
    beforeUnmount() {
        if (this._removeBeforeEach) this._removeBeforeEach()
        if (this._removeAfterEach) this._removeAfterEach()
        clearTimeout(this._finishTimer)
    },
}
</script>

<style scoped>
.loading-bar {
    position: fixed;
    top: 0;
    left: 0;
    height: 2px;
    z-index: 9999;
    pointer-events: none;
}
</style>
